import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { TRPCProvider, makeTrpcClient } from './lib/trpc.js';
import { router } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Bei App-Resume / Tab-Fokus sofort refetchen, sonst driften Countdowns (Konzept, Abschnitt 10).
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 5_000,
      retry: (count, err) => {
        const code = (err as { data?: { code?: string } })?.data?.code;
        if (code === 'UNAUTHORIZED' || code === 'FORBIDDEN' || code === 'NOT_FOUND') return false;
        return count < 2;
      },
    },
  },
});
const trpcClient = makeTrpcClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <RouterProvider router={router} context={{ queryClient }} />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
